<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data(){
    return{
      alarmIndex:0,
      alarmData:{
        "m_module":"m4004",//模块名称或H5页面
        "m_name": "v1001",//指标名称或H5元素
        "m_host": window.location.host,//主机名称
        "m_time": ""+new Date().getTime(),//生成13位时间戳，毫秒（长整数）
        "m_rfc_time":this.$unit.getRFC3339(),//	RFC3339格式时间（字符串）
        "m_appid":"orange",//	应用ID
        "m_id":"orange-"+Math.floor(Math.random()*Math.pow(10,10))+"-"+this.alarmIndex,//唯一ID，应用ID或app包名-10位随机字符串-序号
        "m_zuid":"8983cb85f5c7422fa32c3ab3041036b9",//设备唯一ID，32位UUID
        "b":1,//
        "c":10100,//
        "userGid": window.localStorage.getItem("userInfo")?JSON.parse(window.localStorage.getItem("userInfo")).userGid||'':''//
      },
      isHttp:false,
    }
  },
  created(){
    eventBus.$off('onError'); // 关闭上一次的监听
    eventBus.$on('onError', (mName,message) => {
      // alert(`错误：${_err}`);
      console.log(mName,message)
      if(mName=="v1003"||mName=="v1004"){//接口异常防止死循环
        if(this.isHttp){
          return;
        }
        this.isHttp=true;
      }else{
        this.isHttp=false;
      }
      this.alarmDataHandler(mName,message);
    });
  },
  methods:{
    alarmDataHandler(mName,message){
      this.alarmIndex++;
      console.log(this.alarmIndex )
      this.alarmData.m_id="orange-"+Math.floor(Math.random()*Math.pow(10,10))+"-"+this.alarmIndex;
      this.alarmData.m_name=mName;
      this.alarmData.response=message;
      var headers = {
        "b":1,//
        "c":10100,//
        "OA-APP-ID":"oak",
      }
      var data=window.btoa(encodeURIComponent(JSON.stringify(this.alarmData)));
      // console.log(window.atob(decodeURIComponent(data)))
      this.$http('/oak/unsafe/receive/alarmData', {data},true,headers).then(r => {
        console.log('clickRowHandle:::', r)
      }).catch(err => {
        console.log('clickRowHandle:::', err)
      })
    }
  }

}
</script>
<style lang="stylus">
#app {
  font-family: Helvetica Neue, Helvetica, Arial, PingFang SC, Hiragino Sans GB, Heiti SC, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  // color #2c3e50
  // margin-top 60px
}
</style>
